export default __webpack_public_path__ + "static/media/about-team-22.ab076150.jpg";